import {HeroTitle} from "@/pages/common/Home/components/HeroTitle";

import {forwardRef} from "react";

import {BorderArticle} from "@ui/general/BorderArticle";
import {motion} from "framer-motion";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

const itemAnimation = {
  hidden: {transform: "scale(0.6)", opacity: 0},
  visible: (custom) => ({
    transform: "scale(1)",
    opacity: 1,
    transition: {
      delay: custom * 0.3,
    },
  }),
};

const SalesItem = forwardRef(({key, count, title}, ref) => {
  return (
    <li
      key={key}
      ref={ref}
    >
      <BorderArticle>
        <div>
          <b>{count}</b>
          <span>{title}</span>
        </div>
      </BorderArticle>
    </li>
  );
});

export const MSalesItem = motion(SalesItem);

export const Intro = () => {
  const {t} = useTranslation();

  const sales = [
    {
      count: "1",
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.sales.count_1_title"),
          }}
        />
      ),
    },
    {
      count: "2",
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.sales.count_2_title"),
          }}
        />
      ),
    },
    {
      count: "3",
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.sales.count_3_title"),
          }}
        />
      ),
    },
    {
      count: "4",
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.sales.count_4_title"),
          }}
        />
      ),
    },
  ];

  return (
    <div className={styles.intro}>
      <HeroTitle>
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.intro_title"),
          }}
        />

        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.intro_desc"),
          }}
        />
      </HeroTitle>

      <div className={styles.sales}>
        <h3
          dangerouslySetInnerHTML={{
            __html: t("page.overview.sales.title"),
          }}
        />

        <motion.ul
          initial={"hidden"}
          whileInView={"visible"}
          viewport={{amount: 0, once: true}}
        >
          {sales &&
            sales.length > 0 &&
            sales.map((sale) => (
              <MSalesItem
                key={sale.count}
                custom={sale.count}
                variants={itemAnimation}
                count={sale.count}
                title={sale.title}
              />
            ))}
        </motion.ul>

        <p
          dangerouslySetInnerHTML={{
            __html: t("page.overview.sales.desc"),
          }}
        />
      </div>
    </div>
  );
};
